module.exports = __webpack_public_path__ + "img/top-2-2.c4e5291f.jpg";